// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AffiliatesRouteImport } from './routes/affiliates'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as GeoRouteImport } from './routes/geo'
import { Route as MarketReportsRouteImport } from './routes/market-reports'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TutorialsRouteImport } from './routes/tutorials'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CaseStudiesIndexRouteImport } from './routes/case-studies.index'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies.$slug'
import { Route as ComparisonsIndexRouteImport } from './routes/comparisons.index'
import { Route as ComparisonsSlugRouteImport } from './routes/comparisons.$slug'
import { Route as GeoIndexRouteImport } from './routes/geo.index'
import { Route as GeoSlugRouteImport } from './routes/geo.$slug'
import { Route as LpAgenciesRouteImport } from './routes/lp.agencies'
import { Route as LpAiVisibilityFounderRouteImport } from './routes/lp.ai-visibility-founder'
import { Route as LpAiVisibilityMarketersRouteImport } from './routes/lp.ai-visibility-marketers'
import { Route as LpDirectFoundersRouteImport } from './routes/lp.direct-founders'
import { Route as LpDirectMarketersRouteImport } from './routes/lp.direct-marketers'
import { Route as LpDirectSmbRouteImport } from './routes/lp.direct-smb'
import { Route as LpIntelligentPrRouteImport } from './routes/lp.intelligent-pr'
import { Route as LpOutcomeFoundersRouteImport } from './routes/lp.outcome-founders'
import { Route as LpOutcomeMarketersRouteImport } from './routes/lp.outcome-marketers'
import { Route as LpReplaceAgenciesSMBRouteImport } from './routes/lp.replace-agencies-SMB'
import { Route as LpReplaceAgenciesFoundersRouteImport } from './routes/lp.replace-agencies-founders'
import { Route as LpReplaceAgenciesMarketersRouteImport } from './routes/lp.replace-agencies-marketers'
import { Route as LpScheduleRouteImport } from './routes/lp.schedule'
import { Route as LpScheduleAgencyRouteImport } from './routes/lp.schedule-agency'
import { Route as LpScheduleAgencyBRouteImport } from './routes/lp.schedule-agency-b'
import { Route as MarketReportsIndexRouteImport } from './routes/market-reports.index'
import { Route as MarketReportsSlugRouteImport } from './routes/market-reports.$slug'
import { Route as ProductsIndexRouteImport } from './routes/products.index'
import { Route as ProductsSlugRouteImport } from './routes/products.$slug'
import { Route as TutorialsIndexRouteImport } from './routes/tutorials.index'
import { Route as TutorialsSlugRouteImport } from './routes/tutorials.$slug'
import { Route as UseCasesIndexRouteImport } from './routes/use-cases.index'
import { Route as UseCasesSlugRouteImport } from './routes/use-cases.$slug'
import { Route as LpIntelligentPrIndexRouteImport } from './routes/lp.intelligent-pr.index'
import { Route as LpIntelligentPrPricingRouteImport } from './routes/lp.intelligent-pr.pricing'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AffiliatesRoute = AffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const GeoRoute = GeoRouteImport.update({
            id: '/geo',path: '/geo',getParentRoute: () => rootRouteImport
          })
const MarketReportsRoute = MarketReportsRouteImport.update({
            id: '/market-reports',path: '/market-reports',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TutorialsRoute = TutorialsRouteImport.update({
            id: '/tutorials',path: '/tutorials',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const CaseStudiesIndexRoute = CaseStudiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CaseStudiesRoute
          })
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CaseStudiesRoute
          })
const ComparisonsIndexRoute = ComparisonsIndexRouteImport.update({
            id: '/comparisons/',path: '/comparisons/',getParentRoute: () => rootRouteImport
          })
const ComparisonsSlugRoute = ComparisonsSlugRouteImport.update({
            id: '/comparisons/$slug',path: '/comparisons/$slug',getParentRoute: () => rootRouteImport
          })
const GeoIndexRoute = GeoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GeoRoute
          })
const GeoSlugRoute = GeoSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => GeoRoute
          })
const LpAgenciesRoute = LpAgenciesRouteImport.update({
            id: '/lp/agencies',path: '/lp/agencies',getParentRoute: () => rootRouteImport
          })
const LpAiVisibilityFounderRoute = LpAiVisibilityFounderRouteImport.update({
            id: '/lp/ai-visibility-founder',path: '/lp/ai-visibility-founder',getParentRoute: () => rootRouteImport
          })
const LpAiVisibilityMarketersRoute = LpAiVisibilityMarketersRouteImport.update({
            id: '/lp/ai-visibility-marketers',path: '/lp/ai-visibility-marketers',getParentRoute: () => rootRouteImport
          })
const LpDirectFoundersRoute = LpDirectFoundersRouteImport.update({
            id: '/lp/direct-founders',path: '/lp/direct-founders',getParentRoute: () => rootRouteImport
          })
const LpDirectMarketersRoute = LpDirectMarketersRouteImport.update({
            id: '/lp/direct-marketers',path: '/lp/direct-marketers',getParentRoute: () => rootRouteImport
          })
const LpDirectSmbRoute = LpDirectSmbRouteImport.update({
            id: '/lp/direct-smb',path: '/lp/direct-smb',getParentRoute: () => rootRouteImport
          })
const LpIntelligentPrRoute = LpIntelligentPrRouteImport.update({
            id: '/lp/intelligent-pr',path: '/lp/intelligent-pr',getParentRoute: () => rootRouteImport
          })
const LpOutcomeFoundersRoute = LpOutcomeFoundersRouteImport.update({
            id: '/lp/outcome-founders',path: '/lp/outcome-founders',getParentRoute: () => rootRouteImport
          })
const LpOutcomeMarketersRoute = LpOutcomeMarketersRouteImport.update({
            id: '/lp/outcome-marketers',path: '/lp/outcome-marketers',getParentRoute: () => rootRouteImport
          })
const LpReplaceAgenciesSMBRoute = LpReplaceAgenciesSMBRouteImport.update({
            id: '/lp/replace-agencies-SMB',path: '/lp/replace-agencies-SMB',getParentRoute: () => rootRouteImport
          })
const LpReplaceAgenciesFoundersRoute = LpReplaceAgenciesFoundersRouteImport.update({
            id: '/lp/replace-agencies-founders',path: '/lp/replace-agencies-founders',getParentRoute: () => rootRouteImport
          })
const LpReplaceAgenciesMarketersRoute = LpReplaceAgenciesMarketersRouteImport.update({
            id: '/lp/replace-agencies-marketers',path: '/lp/replace-agencies-marketers',getParentRoute: () => rootRouteImport
          })
const LpScheduleRoute = LpScheduleRouteImport.update({
            id: '/lp/schedule',path: '/lp/schedule',getParentRoute: () => rootRouteImport
          })
const LpScheduleAgencyRoute = LpScheduleAgencyRouteImport.update({
            id: '/lp/schedule-agency',path: '/lp/schedule-agency',getParentRoute: () => rootRouteImport
          })
const LpScheduleAgencyBRoute = LpScheduleAgencyBRouteImport.update({
            id: '/lp/schedule-agency-b',path: '/lp/schedule-agency-b',getParentRoute: () => rootRouteImport
          })
const MarketReportsIndexRoute = MarketReportsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MarketReportsRoute
          })
const MarketReportsSlugRoute = MarketReportsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => MarketReportsRoute
          })
const ProductsIndexRoute = ProductsIndexRouteImport.update({
            id: '/products/',path: '/products/',getParentRoute: () => rootRouteImport
          })
const ProductsSlugRoute = ProductsSlugRouteImport.update({
            id: '/products/$slug',path: '/products/$slug',getParentRoute: () => rootRouteImport
          })
const TutorialsIndexRoute = TutorialsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => TutorialsRoute
          })
const TutorialsSlugRoute = TutorialsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => TutorialsRoute
          })
const UseCasesIndexRoute = UseCasesIndexRouteImport.update({
            id: '/use-cases/',path: '/use-cases/',getParentRoute: () => rootRouteImport
          })
const UseCasesSlugRoute = UseCasesSlugRouteImport.update({
            id: '/use-cases/$slug',path: '/use-cases/$slug',getParentRoute: () => rootRouteImport
          })
const LpIntelligentPrIndexRoute = LpIntelligentPrIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LpIntelligentPrRoute
          })
const LpIntelligentPrPricingRoute = LpIntelligentPrPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => LpIntelligentPrRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const CaseStudiesRouteChildren = {
  CaseStudiesSlugRoute: CaseStudiesSlugRoute,CaseStudiesIndexRoute: CaseStudiesIndexRoute
}

const CaseStudiesRouteWithChildren = CaseStudiesRoute._addFileChildren(CaseStudiesRouteChildren)




const GeoRouteChildren = {
  GeoSlugRoute: GeoSlugRoute,GeoIndexRoute: GeoIndexRoute
}

const GeoRouteWithChildren = GeoRoute._addFileChildren(GeoRouteChildren)




const MarketReportsRouteChildren = {
  MarketReportsSlugRoute: MarketReportsSlugRoute,MarketReportsIndexRoute: MarketReportsIndexRoute
}

const MarketReportsRouteWithChildren = MarketReportsRoute._addFileChildren(MarketReportsRouteChildren)




const TutorialsRouteChildren = {
  TutorialsSlugRoute: TutorialsSlugRoute,TutorialsIndexRoute: TutorialsIndexRoute
}

const TutorialsRouteWithChildren = TutorialsRoute._addFileChildren(TutorialsRouteChildren)




const LpIntelligentPrRouteChildren = {
  LpIntelligentPrPricingRoute: LpIntelligentPrPricingRoute,LpIntelligentPrIndexRoute: LpIntelligentPrIndexRoute
}

const LpIntelligentPrRouteWithChildren = LpIntelligentPrRoute._addFileChildren(LpIntelligentPrRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AffiliatesRoute: AffiliatesRoute,BlogRoute: BlogRouteWithChildren,CaseStudiesRoute: CaseStudiesRouteWithChildren,GeoRoute: GeoRouteWithChildren,MarketReportsRoute: MarketReportsRouteWithChildren,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,TutorialsRoute: TutorialsRouteWithChildren,ComparisonsSlugRoute: ComparisonsSlugRoute,LpAgenciesRoute: LpAgenciesRoute,LpAiVisibilityFounderRoute: LpAiVisibilityFounderRoute,LpAiVisibilityMarketersRoute: LpAiVisibilityMarketersRoute,LpDirectFoundersRoute: LpDirectFoundersRoute,LpDirectMarketersRoute: LpDirectMarketersRoute,LpDirectSmbRoute: LpDirectSmbRoute,LpIntelligentPrRoute: LpIntelligentPrRouteWithChildren,LpOutcomeFoundersRoute: LpOutcomeFoundersRoute,LpOutcomeMarketersRoute: LpOutcomeMarketersRoute,LpReplaceAgenciesSMBRoute: LpReplaceAgenciesSMBRoute,LpReplaceAgenciesFoundersRoute: LpReplaceAgenciesFoundersRoute,LpReplaceAgenciesMarketersRoute: LpReplaceAgenciesMarketersRoute,LpScheduleRoute: LpScheduleRoute,LpScheduleAgencyRoute: LpScheduleAgencyRoute,LpScheduleAgencyBRoute: LpScheduleAgencyBRoute,ProductsSlugRoute: ProductsSlugRoute,UseCasesSlugRoute: UseCasesSlugRoute,ComparisonsIndexRoute: ComparisonsIndexRoute,ProductsIndexRoute: ProductsIndexRoute,UseCasesIndexRoute: UseCasesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)